import { wachExtractThemeToFileForSync } from './store/sagas/watchExtractThemeToFileForSync';

export const sagasThemeToFileForSync = [wachExtractThemeToFileForSync];
export { reducerExtractThemeToFileForSync } from './store/reducer';
export { ModalExtractThemeToFileForSync } from './components/ModalExtractThemeToFileForSync';
export { selectExtractThemeToFileForSync } from './selectors';
export { useSetModalExtract } from './store/actions';
